import { FormattedMessage, defineMessage } from 'react-intl';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';

import HelpArticleLink from '../../../../components/help-article-link';
import { linkIDs } from '../../../../services/link-service/links';

const message = defineMessage({
  description: 'insuffieint data banner message header',
  defaultMessage:
    '<b>Insufficient data in selected date range.</b> Adjusting the dates may provide enough data to populate the charts below. <link>Learn more about Insights</link>',
  id: 'i7Z3Eh',
});

const InsufficientDataBannerMessage = () => {
  return (
    <BannerMessageV2
      content={
        <FormattedMessage
          {...message}
          values={{
            link: (chunks) => <HelpArticleLink articleId={linkIDs.InsightsPages}>{chunks}</HelpArticleLink>,
          }}
        />
      }
      status={BannerStatus.Info}
    />
  );
};

export default InsufficientDataBannerMessage;
